import api from "@/utils/backend-api";
import {
  sendSuccessNotice,
  sendErrorNotice,
  closeNotice,
  getDefaultPagination,
  commitPagination,
} from "@/utils/store-util.js";

import { get } from "lodash";

const state = {
  pagination: {},
  loading: true,
  snackbar: false,
  notice: "",
  checks: [],
};

const getters = {};

const actions = {
  getChecks ({ commit }, id) {
    commit("setLoading", { loading: true });
    api.getData("mail/get-checks?" + id).then(res => {
        commit("setChecks", res.data);
        commitPagination(commit, res.data);
        commit("setLoading", { loading: false });
    });
  },
  closeSnackBar ({ commit }, timeout ) {
    closeNotice(commit, timeout);
  }
};

const mutations = {
  setChecks (state, checks) {
    state.checks = checks;
  },
  setPagination (state, pagination) {
    state.pagination = pagination;
  },
  setLoading (state, { loading }) {
    state.loading = loading;
  },
  setSnackbar (state, { snackbar }) {
    state.snackbar = snackbar;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/mailchecks.js